
/**
 * @param {?} a1
 * @param {?} a2
 * @return {?}
 */
function isPointsEq(a1: string[], a2: string[]): boolean {
    return a1[0] === a2[0] && a1[1] === a2[1];
}
/**
 * @param {?} builtinPlacements
 * @param {?} placementStr
 * @param {?} align
 * @return {?}
 */
export function getAlignFromPlacement(builtinPlacements: Object, placementStr: string, align: {points?: string[]}): Object {
    const /** @type {?} */ baseAlign = builtinPlacements[placementStr] || {};
    return Object.assign({}, baseAlign, align);
}
/**
 * @param {?} builtinPlacements
 * @param {?} prefixCls
 * @param {?} align
 * @return {?}
 */
export function getPopupClassNameFromAlign(builtinPlacements: Object, prefixCls: string, align: {points?: string[]}): string {
    const /** @type {?} */ points = align.points;
    for (const /** @type {?} */ placement in builtinPlacements) {
        if (builtinPlacements.hasOwnProperty(placement)) {
            if (isPointsEq(builtinPlacements[placement].points, points)) {
                return `${prefixCls}-placement-${placement}`;
            }
        }
    }
    return '';
}
